<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      贝尔路站<br>
站点介绍<br>
贝尔路站位于深圳市龙岗区坂雪岗大道和贝尔路交叉口，车站主体呈南北走向，南接坂田北站，北接华为站。 贝尔路站色彩基调以黄色为主，为地下车站，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有4个出入口，车站周边以商业写字楼为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:04	23:27	10号线	3分40秒	6分钟<br>
双拥街	06:41	23:28	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:10	23:27	10号线	4分50秒	7分钟<br>
双拥街	06:49	23:28	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:05	00:27	10号线	4分50秒	7分钟<br>
双拥街	06:41	00:28	10号线	4分50秒	7分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
坂雪岗大道东侧（南）、贝尔路南侧（东）、 坂田商务大厦、深圳远东妇产医院龙岗妇产医院<br><br>
B出入口:<br>
坂雪岗大道东侧（北）、贝尔路北侧（东）、毕加索大道,肖邦路<br><br>
C出入口:<br>
坂雪岗大道西侧（北）、贝尔路北侧（西）、居里夫人大道、新天下集团、神舟电脑、百瑞达工坊<br><br>
D出入口:<br>
坂雪岗大道西侧（南）、贝尔路南侧（西）、冲之大道、坂兴路、平安公园、黄金山公园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 中海日辉台<br>
M221、M383、M567（原B667)、M568、M578、高峰专线37、高快巴士34<br><br>
B出入口:<br>
公交站名： 万科城①,万科城②<br>
321、328、334、E27、M281、M282、M383、M567（原B667)、M568、M578<br><br>
C出入口:<br>
公交站名： 万科城<br>
高快巴士39、高快巴士34、高快巴士40、M383、M481、M567（原B667)、M568、M578、高峰专线37、313、317、321、328、334、339、E8、E27、E32、M221、M281、M282、M346、M309<br><br>
D出入口:<br>
公交站名： 中海日辉台<br>
321、328、334、M221、M282、M383、M547、M567、M568、M578、高峰专线37、高快巴士34<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shihaoxian",
            title: "10号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>